import { Component, HostListener, ChangeDetectorRef, Renderer2, Inject } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { NotificationService } from "@apps/patient-core/src/app/services/notification.service";
import { OverlayService } from "@apps/patient-core/src/app/services/overlay.service";
import { PushUpdatesService } from "@apps/patient-core/src/app/services/push-updates.service";
import { FADE_IN_ANIMATION } from "@apps/patient-core/src/app/utils/animations";
import { SHARED } from "@apps/patient-core/src/app/shared";
import { NavigationService } from "@apps/patient-core/src/app/services/navigation.service";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { PatientMainComponent } from "./components/main/main.component";
import { BaseSessionService } from "@apps/patient-core/src/app/services/abstracts/session.service";
import { NotificationComponent } from "@apps/patient-core/src/app/components/notification/notification.component";
import { BaseAppComponent } from "@apps/patient-core/src/app/components/abstracts/app/app.component";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { DOCUMENT } from "@angular/common";
import { filter } from "rxjs";
import { PORTAL_VIEWER_URL_CHANGE_EVENT } from "@shared/constants";

const { HOST_ZONE } = environment;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [NotificationComponent, SHARED, PatientMainComponent],
  animations: [FADE_IN_ANIMATION],
  providers: [{ provide: Document, useValue: document }],
})
export class PatientAppComponent extends BaseAppComponent {
  @HostListener("window:message", ["$event"]) async onMessage(event) {
    // Used when the patient app is being shown in an iframe so we can logout before changing to a different portal/user
    // Sandbox and production use dentally.com domains (e.g. portal.dentally.com) and other stages use stage-manage.sandbox.portal.dental
    if ((event.origin.endsWith(`.${HOST_ZONE}`) || event.origin.endsWith(".dentally.com")) && event.data === "signout") {
      await this._sessionService.logout();
    }
  }

  constructor(
    protected _router: Router,
    protected _authService: BaseAuthService,
    protected _activatedRoute: ActivatedRoute,
    protected _overlayService: OverlayService,
    protected _changeDetectorRef: ChangeDetectorRef,
    protected _renderer: Renderer2,
    protected _pushUpdatesService: PushUpdatesService,
    protected _notificationService: NotificationService,
    protected _navigationService: NavigationService,
    protected _cacheService: CacheService,
    protected _sessionService: BaseSessionService,
    @Inject(DOCUMENT) protected _document: Document
  ) {
    super(
      _router,
      _authService,
      _activatedRoute,
      _overlayService,
      _changeDetectorRef,
      _renderer,
      _pushUpdatesService,
      _notificationService,
      _navigationService,
      _cacheService,
      _sessionService,
      _document
    );
  }

  override ngOnInit() {
    super.ngOnInit();

    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      if (window.parent) {
        window.parent.postMessage(
          {
            id: PORTAL_VIEWER_URL_CHANGE_EVENT,
            url: event.urlAfterRedirects,
          },
          "*"
        );
      }
    });
  }
}
